export default __webpack_public_path__ + "static/media/Header02.43728505.jpg";